import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
import chartsMaps from './routes/charts-maps'
import formsTable from './routes/forms-tables'
import others from './routes/others'
import partner from './routes/partner'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'tanghuay-round' } },
    ...apps,
    ...dashboard,
    ...pages,
    ...chartsMaps,
    ...formsTable,
    ...uiElements,
    ...others,
    ...partner,
    {
      path: '*',
      redirect: 'tanghuay-round',
    },
  ],
})

router.beforeEach((to, _, next) => {
  if(to.path == '/login-next'){
    localStorage.clear()
    // window.location.reload()
    return next()
  }
  const isLoggedIn = isUserLoggedIn()
  // console.log('login',isLoggedIn)
  // console.log(canNavigate(to))
  
  if (!canNavigate(to)) {
    // console.log('AuthLogin')
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login-next' })

    // If logged in => not authorized
    return next('/')
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()

    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
